export default () => {
    let lang;
    switch (navigator.language) {
        case "tr-TR":
            lang = 'tr';
            break;
        case "tr":
            lang = 'tr';
            break;
        case "TR":
            lang = 'tr';
            break;
        case "de":
            lang = 'en';
            break;
        case "cs":
            lang = 'en';
            break;
        case "cs-CZ":
            lang = 'en';
            break;
        case "CZ":
            lang = 'en';
            break;
        case "ru":
            lang = 'en';
            break;
        case "en":
            lang = 'en';
            break;
        case "en-US":
            lang = 'en';
            break;
        case "US":
            lang = 'en';
            break;
        default:
            lang = 'en';
            break;
    }
    return lang;
}